import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/generic-response.model';
import { CMBoatClassesResponse, Product, ProductDDResponse, ProductResponse, RateSheetDescription, SimpleProductResponse } from '../models/product.model';
import { delayedRetryHttp } from './shared/delayed-retry';
import { UtilityService } from './shared/utility.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

    private baseUrl: string;
    private api: string = 'api/Product';


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async cMProductGetUnused(encryptedUser: string, clpCompanyId: number, clubId : number, siteId : number): Promise<SimpleProductResponse | void> {
        const a = await this.httpClient
            .get<SimpleProductResponse>(`${this.baseUrl}/CMProduct_GetUnused/${clpCompanyId}/${clubId}/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clubId - " + clubId + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cMProductGetUnused"); });
        return a;
    }

    async CMProduct_Get(encryptedUser: string, clpCompanyId: number, clubId: number, siteId: number): Promise<ProductResponse | void> {
        const a = await this.httpClient
            .get<ProductResponse>(`${this.baseUrl}/CMProduct_Get/${clpCompanyId}/${clubId}/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clubId - " + clubId + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cMProductGet"); });
        return a;
    }

    async CMProduct_Get_All(encryptedUser: string, clpCompanyId: number, clubId: number, siteId: number): Promise<ProductResponse | void> {
        const a = await this.httpClient
            .get<ProductResponse>(`${this.baseUrl}/CMProduct_Get_All/${clpCompanyId}/${clubId}/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clubId - " + clubId + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cMProductGet"); });
        return a;
    }

    async cMProductDelete(encryptedUser: string, productId: number): Promise<ProductResponse | void> {
        const a = await this.httpClient
            .get<ProductResponse>(`${this.baseUrl}/CMProduct_Delete/${productId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "productId - " + productId, encryptedUser, "ProductService", "CMProductDelete"); });
        return a;
    }

    async cMProductUpdate(encryptedUser: string, product: Product): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMProduct_Update`, product, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - "+ encryptedUser, encryptedUser, "ProductService", "cMProductUpdate"); });
        return a;
    }

    async cMProductaveRateSheetDescription(encryptedUser: string, rateSheetDescription: RateSheetDescription[]): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMProduct_SaveRateSheetDescription`, rateSheetDescription, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "ProductService", "cMProductaveRateSheetDescription"); });
        return a;
    }

    async cMProductPublishToDraft(encryptedUser: string, siteId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMProduct_PublishToDraft/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cMProductPublishToDraft"); });
        return a;
    }

    async cMProductDraftToPublish(encryptedUser: string, siteId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMProduct_DraftToPublish/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cMProductDraftToPublish"); });
        return a;
    }

    async cMProductclone(encryptedUser: string, clpcompanyId: number, clubId : number, siteId: number, toSiteId : number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMProductclone/${clpcompanyId}/${clubId}/${siteId}/${toSiteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "siteId - " + siteId, encryptedUser, "ProductService", "cloneProducts"); });
        return a;
    }

    async cmBoatClasses_GETLIST(encryptedUser: string): Promise<CMBoatClassesResponse | void> {
        const a = await this.httpClient
            .get<CMBoatClassesResponse>(`${this.baseUrl}/REF_CMBoatClasses_GETLIST`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + encryptedUser, "ProductService", "REF_CMBoatClasses_GETLIST"); });
        return a;
    }
}
